import React from "react";
import { translate } from "Shared/translate";
import * as styles from "./base.scss";
import { alternativeProductLinkImpression, alternativeProductLinkClick, } from "../../TrackingInformation";
import Image from "Shared/ImageFallback";
import ViewTracker from "Shared/ViewObserver/ViewTracker";
import { timeout } from "Shared/timeout";
import classnames from "classnames";
import connect from "Shared/connect";
import { pushState } from "Shared/history";
const getLinkUrl = (url) => {
    url = getDeepestCategoryLinkUrl(url);
    return url + "?inStock=true";
};
export const getDeepestCategoryLinkUrl = (url) => {
    const lastSlash = url.lastIndexOf("/");
    url = url.length >= lastSlash ? url.substring(0, lastSlash) : url;
    return url;
};
export const isLinkVisible = (selectedVariant, product) => {
    return isVisible(selectedVariant, product);
};
const isVisible = (selectedVariant, product) => {
    const visibleFromAvailability = {
        inStock: false,
        lowStock: false,
        outOfStock: true,
        futureDelivery: true,
        selectedDate: false,
        warehouse: false,
        unavailable: false,
    };
    if (!!selectedVariant &&
        !!selectedVariant.availability &&
        selectedVariant.availability.availabilityCode) {
        const isVisible = visibleFromAvailability[selectedVariant.availability.availabilityCode];
        if ((!!isVisible &&
            (!!product.replacementProduct ||
                !!product.recommendedReplacementProduct)) ||
            !!product.hideAlternativeProductsLink ||
            !!product.isDiscontinued) {
            return false;
        }
        return isVisible;
    }
    return false;
};
const onLinkClick = (product) => {
    alternativeProductLinkClick(product);
    timeout(10).then(() => {
        pushState(getLinkUrl(product.url.toString()), {
            skipPartialCache: true,
        });
    });
};
const onView = (visible, product, selectedVariant) => {
    if (!visible)
        return;
    const outOfStock = !!selectedVariant &&
        !!selectedVariant.availability &&
        selectedVariant.availability.availabilityCode == "outOfStock";
    alternativeProductLinkImpression(product, outOfStock);
};
const ProductAlternativesLink = ({ product, selectedVariant, isList, alternativeLink, }) => {
    if (!isVisible(selectedVariant, product)) {
        return React.createElement("br", null);
    }
    const getImageUrl = () => {
        return !!alternativeLink && alternativeLink.imageUrl;
    };
    const getAmount = () => {
        return !!alternativeLink && alternativeLink.amount;
    };
    return (!!getAmount() && (React.createElement("div", { className: styles.main },
        React.createElement(ViewTracker, { key: "alternativeProductsLinkViewTracker", onView: (visible) => onView(visible, product, selectedVariant) },
            React.createElement(React.Fragment, null,
                React.createElement("a", { "data-opti-id": "component-see-similar-url", "data-skip-partial-cache": true, className: styles.link, onClick: () => onLinkClick(product) }, translate("/ProductListing/ProductAlternativesLinkText")),
                !!getImageUrl() && !!getAmount() && (React.createElement("div", { "data-opti-id": "component-see-similar-image", className: classnames(styles.info, { [styles.isList]: isList }), onClick: () => onLinkClick(product) },
                    React.createElement(Image, { src: getImageUrl(), size: "tiny", maxSize: "tiny", itemProp: "image", fadeIn: true }),
                    React.createElement("div", { className: styles.counter }, getAmount()))))))));
};
export default connect((state, ownProps) => ({
    alternativeLink: !!state.product.alternativeProductLinks &&
        !!state.product.alternativeProductLinks[ownProps.product.code] &&
        state.product.alternativeProductLinks[ownProps.product.code],
}))(ProductAlternativesLink);
